import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useReactlytics } from '@americanexpress/reactlytics';
import {
  SafeKeyLogo, trackCsEvent, ONE_CMS_API, WAIT_ID,
} from '@americanexpress/gravity-core';
import { ProgressCircle } from '@americanexpress/dls-react';

export const WaitScreen = ({
  show, gravityAuthnUrl, screenId, acsTransId, token, locale, gemUrl, updateDataHeader, dataHeader,
}) => {
  const { track } = useReactlytics();
  const [waitscreenT0] = useState(global.BROWSER && performance.now());
  const [waitscreenComplete, setWaitscreenComplete] = useState(false);
  const [cmsData, setCmsData] = useState(null);

  useEffect(() => {
    const abortController = new AbortController();
    const { signal } = abortController;
    if (locale) {
      const apiUrl = `${gemUrl}${ONE_CMS_API}/${locale}/wait_screen.json`;
      fetch(apiUrl, { signal })
        .then((res) => res.json())
        .then((response) => {
          setCmsData(response);
        })
        .catch(() => null);
    }
    return () => {
      abortController.abort();
    };
  }, [locale]);

  useEffect(() => {
    const waitscreenT1 = performance.now();
    const duration = ((waitscreenT1 - waitscreenT0) / 1000).toFixed(2);

    if (screenId && !waitscreenComplete && duration > 1) {
      track({
        event: {
          detail: `duration: ${duration}`,
          element: 'waitscreen',
          identifier: 'axp-gravity-root',
          meta: { acs_trans_id: acsTransId, screenId: WAIT_ID },
          type: 'impression',
          timestamp: new Date().toISOString(),
        },
      });
      trackCsEvent({
        element: 'waitscreen', meta: { screenId: WAIT_ID },
      }, 'WTE', gravityAuthnUrl, acsTransId, token, `${duration}`, dataHeader, updateDataHeader);
    }

    if (screenId) {
      setWaitscreenComplete(true);
    }
  }, [screenId]);

  useEffect(() => {
    if (acsTransId && token) {
      trackCsEvent({
        element: 'waitscreen', meta: { screenId: WAIT_ID },
      }, 'impression', gravityAuthnUrl, acsTransId, token, null, dataHeader, updateDataHeader);
    }
  }, [acsTransId, token]);

  if (!show) return null;
  return (
    <div id="safekeyHeader">
      <header className="safekey-header row">
        <div className="col-sm-5 col-xs-5 pad-0-l">
          <img
            className="header-logo"
            src={SafeKeyLogo}
            alt="SafeKey"
          />
        </div>
      </header>

      <div id="safekeyBodyWrap" className="safekey-body-wrap no-footer-wrap">
        <div
          className="safekey-body flex flex-column flex-justify-center flex-align-center text-align-center"
          id="spinner"
        >
          <ProgressCircle size="lg" className="safekey-spinner" />
          {cmsData && !waitscreenComplete && <p className="margin-2-t text-align-center">{cmsData.verify.text}</p>}
        </div>
      </div>
    </div>
  );
};

WaitScreen.propTypes = {
  show: PropTypes.bool.isRequired,
  screenId: PropTypes.string.isRequired,
  acsTransId: PropTypes.string.isRequired,
  gravityAuthnUrl: PropTypes.string.isRequired,
  token: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  gemUrl: PropTypes.string.isRequired,
  updateDataHeader: PropTypes.func.isRequired,
  dataHeader: PropTypes.string.isRequired,
};

export default WaitScreen;
